import React from "react";
import { app as appUI } from "@markedesk/plugin-sdk/ui";
import PluginBridge from "../index";
import SocketStatusIndicator from "../../SocketStatusIndicator";
import LanguageSwitcher from "../../Navbar/LanguageSwitcher";
import DarkModeToggle from "../../Navbar/DarkModeToggle";
import RefreshButton from "../../Navbar/RefreshButton";
import NotificationsVolume from "../../NotificationsVolume";
import NotificationsPopOver from "../../NotificationsPopOver";
import AnnouncementsPopover from "../../AnnouncementsPopover";
import ChatPopover from "../../../pages/Chat/ChatPopover";

const S = appUI.slots;

/**
 * Conteúdo nativo da barra superior (navbar). Cada item é envolto num
 * PluginBridge do seu próprio slot (NAVBAR_*) — assim plugins podem
 * estender/interceptar cada ponto individualmente.
 *
 * A navbar como um todo é renderizada pelo layout dentro de um
 * <PluginBridge slot={NAVBAR}> — este componente é o children daquele bridge,
 * e os itens de plugin gerais do slot NAVBAR aparecem logo após.
 *
 * As props extras (volume, setVolume) vêm do layout.
 */
export default function NavbarSlot({ context = {}, volume, setVolume }) {
  return (
    <>
      <PluginBridge slot={S.NAVBAR_SOCKET_STATUS} context={context}>
        <SocketStatusIndicator />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_LANGUAGE} context={context}>
        <LanguageSwitcher />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_THEME} context={context}>
        <DarkModeToggle />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_VOLUME} context={context}>
        <NotificationsVolume volume={volume} setVolume={setVolume} />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_REFRESH} context={context}>
        <RefreshButton />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_NOTIFICATIONS} context={context}>
        <NotificationsPopOver volume={volume} />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_ANNOUNCEMENTS} context={context}>
        <AnnouncementsPopover />
      </PluginBridge>

      <PluginBridge slot={S.NAVBAR_CHAT} context={context}>
        <ChatPopover />
      </PluginBridge>
    </>
  );
}
